<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
          label="KEY">
          {{model.id}}
        </a-form-model-item>
        <a-form-model-item
          prop="name"
          label="名称">
          {{model.name}}
        </a-form-model-item>

        <a-form-model-item
          label="关注回复内容">
          <a-textarea :rows="6" placeholder="请输入" v-model="model.subscribeResult" />
        </a-form-model-item>
        <a-form-model-item
          label="操作">
          <a-button  type="primary" @click="addMessageRes">
            添加自动回复配置
          </a-button>
        </a-form-model-item>
        <template v-for="(item,index) in model.messageResList">
          <a-form-model-item
            :label="'自动回复配置'+(index+1)">
            <a-input placeholder="请输入关键字" v-model="item.keyword" />
            <a-textarea :rows="4" placeholder="请输入回复内容" v-model="item.message" />
            <a-button  type="primary" @click="deleteMessageRes">
              删除
            </a-button>
            <a-button  type="primary" @click="addMessageRes" style="margin-left: 10px">
              继续添加
            </a-button>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "WechatConfigMessageModal",
    components: { ATextarea },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{

        },
        confirmLoading: false,
        url: {
          edit: "/management/wechatConfig/editRes",
        },
      }
    },
    created () {
    },
    methods: {
      addMessageRes(){
        this.model.messageResList.push({})
      },
      deleteMessageRes(index){
        this.$confirm({
          title: '删除',
          content: '确认删除吗?',
          onOk:()=> {
            this.model.messageResList.splice(index,1)
          }
        })
      },
      edit (record) {
        let messageResList = record.messageRes ? JSON.parse(record.messageRes) : []
        this.model = {
          id:record.id,
          name:record.name,
          subscribeResult:record.subscribeResult,
          messageResList:messageResList
        };
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {

        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let formData = this.model;
            if(formData.messageResList && formData.messageResList.length>0){
              formData.messageRes = JSON.stringify(formData.messageResList)
            }else{
              formData.messageRes = ''
            }
            delete formData.messageResList
            httpAction(this.url.edit,formData,'put').then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>